var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{staticStyle:{"padding-top":"128px"},attrs:{"status":"500","title":"5xx","sub-title":"抱歉，服务器错误"}})
}
var staticRenderFns = []

export { render, staticRenderFns }